import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import PrayerTimes from "@/components/PrayerTimes";
import AnnouncementsTicker from "@/components/AnnouncementsTicker";
import PhotoGallery from "@/components/PhotoGallery";
import AboutSection from "@/components/AboutSection";
import EventsSection from "@/components/EventsSection";
import MadrasaSection from "@/components/MadrasaSection";
import CommitteeSection from "@/components/CommitteeSection";
import ContactSection from "@/components/ContactSection";
import Footer from "@/components/Footer";

export default function Home() {
  const [content, setContent] = useState(null);
  const [times, setTimes] = useState(null);
  const [announcements, setAnnouncements] = useState([]);
  const [events, setEvents] = useState([]);
  const [photos, setPhotos] = useState([]);
  const [committee, setCommittee] = useState([]);

  useEffect(() => {
    (async () => {
      const [c, p, a, e, ph, cm] = await Promise.all([
        api.get("/site-content").then(r => r.data).catch(() => null),
        api.get("/prayer-times").then(r => r.data).catch(() => null),
        api.get("/announcements").then(r => r.data).catch(() => []),
        api.get("/events").then(r => r.data).catch(() => []),
        api.get("/photos").then(r => r.data).catch(() => []),
        api.get("/committee").then(r => r.data).catch(() => []),
      ]);
      setContent(c);
      setTimes(p);
      setAnnouncements(a);
      setEvents(e);
      setPhotos(ph);
      setCommittee(cm);
    })();
  }, []);

  return (
    <div data-testid="home-page" className="min-h-screen bg-stone-50">
      <Navbar />
      <Hero content={content} />
      <AnnouncementsTicker items={announcements} />
      <PrayerTimes times={times} />
      <PhotoGallery photos={photos} />
      <AboutSection content={content} />
      <EventsSection events={events} />
      <MadrasaSection content={content} />
      <CommitteeSection members={committee} />
      <ContactSection content={content} />
      <Footer content={content} />
    </div>
  );
}
